import React from "react";
import { classnames } from "../../utils/text";
import { dateToViewFormatWithDayName, } from "../../utils/date";
import DataComponent from "../DataComponent";
import { DEFAULT_VACATION_DAY_TYPE_LIST } from "../../constants/VACATION";
import clockIcon from "../../assets/images/icon/clock-icon.svg"
import Icon from "../Icon";
const VacationDateItem = ({
  schedule, // date, vacationDayType //all, half, quarter, startTime, endTime
  className,
  onChange,
  ...props
}) => {

  const _onChange = (e) => {

    if (schedule.isSingle && !e.target) {
      onChange({
        ...schedule,
        ...e['endTime.from'] ? { startTime: e['endTime.from'] } : {},
        ...e['endTime.to'] ? { endTime: e['endTime.to'] } : {},
      })
    } else {
      const { value, name } = e.target
      onChange({
        ...schedule,
        ...name ? { [name]: value } : e.target
      })
    }
  }

  return (
    <div className={classnames("vacation-date-item", `vacation-type-${schedule.vacationDayType}`, className)} {...props}>
      <div className='vacation-date-top'>
        <div className='date-display'>
          {dateToViewFormatWithDayName(schedule.date)}
        </div>
        <DataComponent
          field={{
            type: 'select',
            key: 'vacationDayType',
            options: {
              list: DEFAULT_VACATION_DAY_TYPE_LIST.filter(type => {
                return !((!schedule.isFirst && !schedule.isLast) && (type.value === 'half' || type.value === 'quarter')) || schedule.isSingle
              })
            },
            defaultValue: schedule.vacationDayType
          }}
          form={schedule}
          onChange={_onChange}
        />
      </div>
      {
        (schedule.vacationDayType === 'half' || schedule.vacationDayType === 'quarter') && (
          <div className='vacation-date-bottom'>
            <div className='date-display'>
              <Icon src={clockIcon}></Icon>
              <span>
                {!schedule.isSingle &&
                  (schedule.isFirst ? '시작시간' : '종료시간')
                }
              </span>
            </div>
            <DataComponent
              field={{
                type: 'timepicker',
                key: schedule.isFirst ? 'startTime' : 'endTime',
                // defaultValue: {
                //   ...schedule.isSingle ?
                //     { from: schedule.startTime, to: schedule.endTime }
                //     : {
                //       from: schedule.isFirst ? schedule.startTime : schedule.endTime
                //     }

                // },
                isRange: schedule.isSingle
              }}
              form={schedule}
              onChange={(e) => {
                _onChange(schedule.isSingle ? {
                  ...e
                } : {
                  target: e
                })
              }}
            />
            <div className="date-type">

              {!schedule.isSingle &&
                (schedule.isFirst ? '(퇴근시간)' : '(출근시간)')
              }
            </div>
          </div>
        )
      }

    </div>
  );
};

export default VacationDateItem;
